import VmIDE from './VmIDE.jsx'
import {redirect} from 'react-router-dom'
import {useUser} from '@/biz/user.mjs'

export default () => {
    const user = useUser()

    const loader = ({request: {url}}) => {
        const {pathname, search} = new URL(url)
        if (!user) {
            if ('/' !== pathname) {
                const r = encodeURIComponent(pathname + search)
                return redirect(`/login?r=${r}`)
            }
            else {
                return redirect('/login')
            }
        } else {
            return null
        }
    }

    return {
        path: '/vmIDE',
        element: <VmIDE />,
        loader,
    }
}
